export var SIZES = {
  tiny: {
    fontSize: '8px',
    fontWeight: 400,
    lineHeight: '10px'
  },
  small: {
    fontSize: '10px',
    fontWeight: 400,
    lineHeight: '12px'
  },
  intermediate: {
    fontSize: '11px',
    fontWeight: 400,
    lineHeight: '16px'
  },
  regular: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px'
  },
  medium: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px'
  },
  large: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px'
  }
};